import cx from 'clsx';
import * as React from 'react';
import styles from './shared-addons-section.module.css';

interface SharedAddon {
  description: string;
  iconLightPath: string;
  iconDarkPath: string;
}

interface SharedAddonsSectionProps {
  title: string;
  addons: SharedAddon[];
}

export function SharedAddonsSection({ title, addons }: SharedAddonsSectionProps): React.ReactNode {
  return (
    <div className={styles.container} data-test-shared-addons>
      <h3 className={cx('heading-subsection', styles.title)} data-test-shared-addons-title>
        {title}
      </h3>
      <ul className={styles.list}>
        {addons.map(({ description, iconLightPath, iconDarkPath }, index) => (
          <li className={styles['list-item']} data-test-shared-addon={index} key={description}>
            <div
              aria-hidden="true"
              className={cx('mr-8', styles.image)}
              style={
                {
                  '--icon-light-path': `url(${iconLightPath})`,
                  '--icon-dark-path': `url(${iconDarkPath})`,
                } as React.CSSProperties
              }
            />
            <span className="body-standard">{description}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
